import { IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { InputHTMLAttributes } from 'react'
import { Col } from 'reactstrap';
import OptionQuestions from './OptionQuestions';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IQuestionTypeModel>,
    item: IQuestionTypeModel,
    index: any,
    elementRef: any
    clickHandler: any,
    hideDetails: string
}

function NoneQuestions({ data, item, index, elementRef, clickHandler, hideDetails, ...rest }: inputProps, ref) {
    const subQuestions = hideDetails ? data.filter(options => options.ParentId === item.Identifier && options.QuestionnaireTypeEnumName != hideDetails) : data.filter(options => options.ParentId === item.Identifier);

    return (
        <Col style={{ borderBottom: "1px solid #f7f4f4" }} ref={elementRef} size="12" key={index} className="pt-0 mt-0 mb-2">
            <div className="pt-0 mt-0 bg-color-white yes-no-items">
                {(!hideDetails)
                    ?
                    <p className="questionaire-sub-question text-dofy fw-bold m-0">{item.DisplayName}</p>
                    :
                    (hideDetails && item.QuestionnaireTypeEnumName != hideDetails)
                        ?
                        <p className="questionaire-sub-question text-dofy fw-bold m-0">{item.DisplayName}</p>
                        :
                        null
                }
            </div>
            <div className=''>
                {subQuestions && subQuestions[1]?.AnswerType === "Option" ?
                    <OptionQuestions data={subQuestions} index={index} elementRef={elementRef} clickHandler={clickHandler}></OptionQuestions>
                    : ''}
            </div>
            {/* <p id={`err-yesno-text-${item.Id}`} className="err-yesno-text err-yesno-text-hide">Please specify a answer for question.</p> */}
        </Col>
    )
}

export default NoneQuestions
